import { LOGIN_SUCCESS, LOGIN_ERROR, LOGOUT, SHOW_DATE_QUERY_INPUT, HIDE_DATE_QUERY_INPUT } from "./mutation-types";
import router from "@/router";


const mutations = {
    [LOGIN_SUCCESS](state, payload) {
        state.accountUid = payload.accountUid;
        state.accountName = payload.accountName;
        state.userName = payload.userName;
        state.userEmail = payload.userEmail;
        state.userRoles = payload.userRoles;
        state.userToken = payload.userToken;
    },
    [LOGIN_ERROR](state, error) {
        console.log(error);
        state.accountUid = "";
        state.accountName = "";
        state.userName = "";
        state.userEmail = "";
        state.userRoles = "";
        state.userToken = "";
    },
    [LOGOUT](state) {
        localStorage.removeItem("accountUid");
        localStorage.removeItem("accountName");
        localStorage.removeItem("userName");
        localStorage.removeItem("userEmail");
        localStorage.removeItem("userRoles");
        localStorage.removeItem("userToken");
        state.accountUid = "";
        state.accountName = "";
        state.userName = "";
        state.userEmail = "";
        state.userRoles = "";
        state.userToken = "";
        router.push({ path: "/login" });
    },
    [SHOW_DATE_QUERY_INPUT](state) {
        state.showDateSearch = true;
    },
    [HIDE_DATE_QUERY_INPUT](state) {
        state.showDateSearch = false;
    },
}
export default mutations;